<template>
  <div class="header-table">
    <div class="header-groups">
      <template v-for="roomEntry in roomsWithEmployees" :key="roomEntry.room.id">
        <div
          class="room-group"
          :style="{ width: empColWidth * roomEntry.employees.length + 'px' }"
        >
          <div class="cabinet-cell">
            <span class="cabinet-title">{{ roomEntry.room.name }}</span>
          </div>
          <div
            class="employee-grid"
            :style="{ gridTemplateColumns: `repeat(${roomEntry.employees.length}, ${empColWidth}px)` }"
          >
            <template v-for="emp in roomEntry.employees" :key="emp.user_id">
              <div class="employee-cell">
                <div class="employee-content">
                  <EmployeeAvatar :name="emp.user_name" :avatar-url="emp.avatar" :size="avatarSize" />
                  <span
                    class="employee-name"
                    :title="employeeMeta(emp)"
                    :style="employeeNameStyle(emp)"
                  >{{ employeeMeta(emp) }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <div v-if="scrollbarWidth" class="header-scroll-fake-scrollbar" :style="{ width: scrollbarWidth + 'px' }"></div>
    </div>
  </div>
</template>

<script>
import EmployeeAvatar from '@/components/util/calendar/EmployeeAvatar.vue'

export default {
  name: 'HeaderCabinetsAndEmployees',
  components: { EmployeeAvatar },
  props: {
    roomsWithEmployees: Array,
    empColWidth: { type: Number, default: 200 },
    scrollbarWidth: { type: Number, default: 16 },
    fallbackEmail: { type: String, default: '' }
  },
  computed: {
    avatarSize() {
      return Number(this.empColWidth) <= 190 ? 20 : 22
    }
  },
  methods: {
    employeeMeta(emp) {
      return emp.user_email || emp.email || this.fallbackEmail || emp.user_name
    },
    employeeNameStyle(emp) {
      const value = String(this.employeeMeta(emp) || '')
      const length = Math.max(value.length, 1)
      const columnWidth = Number(this.empColWidth) || 200
      const availableWidth = Math.max(columnWidth - 38, 120)
      const calculatedFontSize = availableWidth / (length * 0.52)
      const maxFontSize = columnWidth <= 190 ? 14 : 16
      const fontSize = Math.max(9, Math.min(maxFontSize, calculatedFontSize))
      return {
        fontSize: `${fontSize.toFixed(2)}px`,
        fontWeight: 300
      }
    }
  }
}
</script>

<style scoped>
.header-scroll-fake-scrollbar {
  background: transparent;
  pointer-events: none;
  flex: 0 0 auto;
  height: 100%;
}

.header-table {
  background: transparent;
  user-select: none;
  font-family: var(--ui-font-family-base);
  width: max-content;
  min-width: 100%;
}

.header-groups {
  display: flex;
  align-items: stretch;
  width: max-content;
  min-width: 100%;
}

.room-group {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: center;
  height: var(--calendar-header-block-height, 72px);
  background: var(--cal-surface-header);
  border-radius: 6px;
  box-shadow: none;
  overflow: hidden;
  margin-bottom: 0;
}

.employee-grid {
  display: grid;
  align-items: stretch;
}

.cabinet-cell {
  background: transparent;
  color: var(--cal-text-primary);
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  height: 32px;
  box-sizing: border-box;
  font-size: 23px;
  line-height: 1;
  overflow: hidden;
}

.cabinet-title {
  display: block;
  line-height: 1;
  text-align: center;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.employee-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 2px;
  height: 24px;
  box-sizing: border-box;
  background: transparent;
  overflow: hidden;
}

.employee-cell + .employee-cell {
  box-shadow: none;
}

.employee-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  transform: translateY(-1px);
}

.employee-name {
  flex: 0 1 auto;
  min-width: 0;
  max-width: calc(100% - 27px);
  font-size: 13px;
  color: var(--cal-text-regular);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: clip;
  display: block;
  text-align: center;
  cursor: pointer;
  line-height: 1;
  letter-spacing: 0;
  font-family: "Bahnschrift", var(--ui-font-family-base);
  font-weight: 300 !important;
}
</style>

